<template>
  <div id="tour-results-page" class="flex flex-1 flex-col space-y-2">
    <div class="flex flex-1">
      <DashboardHeaderTab :title="'Results'" :tabs="tabs" :activeTab="activeTab" :setActiveTab="setActiveTab"
        :toggleSidebar="toggleSidebar" />
    </div>
  </div>
</template>

<script setup lang="ts">
import DashboardHeaderTab from '@/components/DashBoard/common/DashboardHeaderTab.vue';
import { useTabs } from '@/composables/useTabs';
import { useTertiaryDashboard } from '@/composables/useTertiaryDashboard';
import { useUserStore } from '@/store/userStore';
import { storeToRefs } from 'pinia';
import { useDebugMode } from '@/composables/useDebugMode';

const toggleSidebar = inject<() => void>('toggleSidebar', () => { });
const { enabled: debugEnabled } = useDebugMode();
const userStore = useUserStore();
const { currentUser } = storeToRefs(userStore);
const { resultsTabs } = useTertiaryDashboard(currentUser, debugEnabled);

const tabs = computed(() => resultsTabs.value);
const { activeTab, setActiveTab } = useTabs(tabs);
</script>

<style></style>
